import { type ReactNode, useEffect, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import '@/workchat/v3/components/UserInfiniteList/UserInfiniteList.scss';

interface UserInfiniteListProps {
  userRows: ReactNode[];
  hasMore: boolean;
  loadMore: () => void;
}

export function UserInfiniteList({ userRows, hasMore, loadMore }: UserInfiniteListProps) {
  const ref = useRef<any>(null);

  /** Effect to re-trigger loadMore when the list size changes without scrolling
   * (i.e. removing Users from the list programmatically)
   */
  useEffect(() => {
    ref.current?.el?.dispatchEvent(new CustomEvent('scroll'));
  }, [userRows]);

  return (
    <div className="UserInfiniteList">
      <InfiniteScroll
        ref={ref}
        dataLength={userRows.length}
        next={loadMore}
        hasMore={hasMore}
        loader={<div className="loading-more">Loading...</div>}
        height={'100%'}
      >
        <ul className="user-list">{userRows}</ul>
      </InfiniteScroll>
    </div>
  );
}
